"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[911],{

/***/ 85326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GoogleAdsBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constant/env.ts
var env = __webpack_require__(34572);
// EXTERNAL MODULE: ./src/utils/lodash/isServer/index.ts
var isServer = __webpack_require__(48086);
;// CONCATENATED MODULE: ./src/components/GoogleAdsBanner/constants.ts
var BANNER_SIZE = {
    leaderBoard: {
        width: "728px",
        height: "90px"
    },
    mobileBanner: {
        width: "300px",
        height: "50px"
    },
    mediumRectangle: {
        width: "300px",
        height: "136px"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/GoogleAdsBanner/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ins {\n    display: inline-block;\n    width: 100%;\n    height: inherit;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8fa5767c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});

;// CONCATENATED MODULE: ./src/components/GoogleAdsBanner/index.tsx









function GoogleAdsBanner(_param) {
    var bannerType = _param.bannerType, slotId = _param.slotId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "bannerType",
        "slotId"
    ]);
    (0,react.useEffect)(function() {
        if (isServer/* isClient */.C && env/* SERVER_ENV */.Km === "production") {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bannerType: bannerType
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ins", {
            className: "adsbygoogle",
            style: (0,_object_spread/* default */.Z)({
                display: "inline-block"
            }, BANNER_SIZE[bannerType]),
            "data-ad-client": "ca-pub-7810616757902075",
            "data-ad-slot": slotId
        })
    }));
};


/***/ }),

/***/ 63985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThumbsDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);


function ThumbsDown(param) {
    var width = param.width, height = param.height, color = param.color;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.34457 11.7983L9.57041 8.56667C9.78624 8.35083 9.90874 8.05333 9.90874 7.74417V1.91667C9.90874 1.275 9.38374 0.75 8.74207 0.75H3.49791C3.03124 0.75 2.61124 1.03 2.43041 1.45583L0.52874 5.895C0.0329069 7.05 0.87874 8.33333 2.13291 8.33333H5.42874L4.87457 11.005C4.81624 11.2967 4.90374 11.5942 5.11374 11.8042C5.45791 12.1425 6.00624 12.1425 6.34457 11.7983ZM12.2479 0.75C11.6062 0.75 11.0812 1.275 11.0812 1.91667V6.58333C11.0812 7.225 11.6062 7.75 12.2479 7.75C12.8896 7.75 13.4146 7.225 13.4146 6.58333V1.91667C13.4146 1.275 12.8896 0.75 12.2479 0.75Z",
            fill: color || theme.colors.gray500
        })
    });
};


/***/ }),

/***/ 2953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThumbsUp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);


function ThumbsUp(param) {
    var width = param.width, height = param.height, color = param.color;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.65398 1.20161L4.42232 4.43327C4.20648 4.64911 4.08398 4.94661 4.08398 5.25577V11.0833C4.08398 11.7249 4.60898 12.2499 5.25065 12.2499H10.5007C10.9673 12.2499 11.3873 11.9699 11.574 11.5441L13.4757 7.10494C13.9657 5.94994 13.1198 4.66661 11.8657 4.66661H8.56982L9.12398 1.99494C9.18232 1.70327 9.09482 1.40577 8.88482 1.19577C8.54065 0.857441 7.99232 0.857441 7.65398 1.20161ZM1.75065 12.2499C2.39232 12.2499 2.91732 11.7249 2.91732 11.0833V6.41661C2.91732 5.77494 2.39232 5.24994 1.75065 5.24994C1.10898 5.24994 0.583984 5.77494 0.583984 6.41661V11.0833C0.583984 11.7249 1.10898 12.2499 1.75065 12.2499Z",
            fill: color || theme.colors.gray500
        })
    });
};


/***/ }),

/***/ 6089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ View; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);


function View(param) {
    var width = param.width, height = param.height, color = param.color;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6.99674 0.625C4.08008 0.625 1.58924 2.43917 0.580078 5C1.58924 7.56083 4.08008 9.375 6.99674 9.375C9.91341 9.375 12.4042 7.56083 13.4134 5C12.4042 2.43917 9.91341 0.625 6.99674 0.625ZM6.99674 7.91667C5.38674 7.91667 4.08008 6.61 4.08008 5C4.08008 3.39 5.38674 2.08333 6.99674 2.08333C8.60674 2.08333 9.91341 3.39 9.91341 5C9.91341 6.61 8.60674 7.91667 6.99674 7.91667ZM6.99674 3.25C6.02841 3.25 5.24674 4.03167 5.24674 5C5.24674 5.96833 6.02841 6.75 6.99674 6.75C7.96508 6.75 8.74674 5.96833 8.74674 5C8.74674 4.03167 7.96508 3.25 6.99674 3.25Z",
            fill: color || theme.colors.gray800
        })
    });
};


/***/ }),

/***/ 93247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalJobdomEditor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 2 modules
var Button = __webpack_require__(71664);
// EXTERNAL MODULE: ./src/components/Input/index.tsx + 1 modules
var Input = __webpack_require__(19921);
// EXTERNAL MODULE: ./src/components/ModalBase/index.tsx + 1 modules
var ModalBase = __webpack_require__(49900);
// EXTERNAL MODULE: ./src/hooks/query/user/useMyInfoQuery.tsx + 2 modules
var useMyInfoQuery = __webpack_require__(9419);
// EXTERNAL MODULE: ./src/utils/common/thirdPartyEvent.ts
var thirdPartyEvent = __webpack_require__(44278);
// EXTERNAL MODULE: ./src/features/board/constants.ts
var constants = __webpack_require__(10847);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/utils/lodash/isEmpty/index.ts
var isEmpty = __webpack_require__(95129);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/components/InputHashtag/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  padding: 8px 12px;\n  min-height: 48px;\n  border: 1px solid #ebebeb;\n  background-color: white;\n  border-radius: 4px;\n  color: #333;\n  font-size: 16px;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-width: 0;\n  width: ",
        ";\n  height: 30px;\n  line-height: 30px;\n\n  &::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 3px 7px;\n  height: 25px;\n  line-height: 25px;\n  border-radius: 16.5px;\n  background-color: #666666;\n  padding: 0 28px 0 10px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 13px;\n  height: 13px;\n  background: #9b9b9b;\n  border-radius: 50%;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 6px;\n    height: 1px;\n    background: #666666;\n  }\n\n  &::before {\n    top: 6px;\n    left: 4px;\n    transform: rotate(-45deg);\n  }\n\n  &::after {\n    top: 6px;\n    left: 4px;\n    transform: rotate(45deg);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d36ca499-0"
})(_templateObject());
var style_Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-d36ca499-1"
})(_templateObject1(), function(param) {
    var expand = param.expand;
    return expand ? "100%" : "160px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var HashTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d36ca499-2"
})(_templateObject2());
var Delete = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d36ca499-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/components/InputHashtag/index.tsx





function InputHashtag(param) {
    var onChange = param.onChange, _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? [] : _defaultValue;
    var ref = (0,react.useState)(""), currentHashtag = ref[0], setCurrentHashTag = ref[1];
    var ref1 = (0,react.useState)(defaultValue), hashtags = ref1[0], setHashTags = ref1[1];
    var handleChange = function(e) {
        setCurrentHashTag(e.target.value.replace(/\s+/, ""));
    };
    var handleKeyDown = function(e) {
        if ((e.key === "Space" || e.code === "Space" || e.key === "Enter" || e.code === "Enter" || e.keyCode === 32 || e.keyCode === 13) && !(0,isEmpty/* isEmpty */.x)(currentHashtag.replace(/\s+/, ""))) {
            e.stopPropagation();
            e.preventDefault();
            setCurrentHashTag("");
            var newState = (0,_to_consumable_array/* default */.Z)(hashtags).concat([
                currentHashtag
            ]);
            setHashTags(newState);
            if (onChange) {
                onChange(newState);
            }
        }
    };
    var handleDeleteTag = (0,react.useCallback)(function(index) {
        var newState = (0,_to_consumable_array/* default */.Z)(hashtags);
        newState.splice(index, 1);
        setHashTags(newState);
        if (onChange) {
            onChange(newState);
        }
    }, [
        hashtags
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            hashtags.map(function(tag, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HashTag, {
                    children: [
                        tag,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete, {
                            onClick: function() {
                                return handleDeleteTag(index);
                            }
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Input, {
                placeholder: "#",
                onChange: handleChange,
                onKeyUp: handleKeyDown,
                value: currentHashtag,
                expand: hashtags.length === 0
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Icon/Search.tsx
var Search = __webpack_require__(34383);
// EXTERNAL MODULE: ./src/hooks/query/company/useCompanyAutoComplete.tsx
var useCompanyAutoComplete = __webpack_require__(40234);
// EXTERNAL MODULE: ./src/hooks/useDocumentClick.ts
var useDocumentClick = __webpack_require__(63740);
;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/components/SearchCompany/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 360px;\n  height: 30px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #d6d6d6;\n  padding-left: 40px;\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 2px;\n  left: 0;\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 30px;\n  line-height: 30px;\n  background: none;\n  border-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  outline: 0;\n  appearance: none;\n  background-color: transparent;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  transform: translate3d(0, 100%, 0);\n  width: 100%;\n  min-height: 180px;\n  max-height: 340px;\n  padding: 16px 0 8px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n  z-index: 1001;\n  overflow-y: auto;\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 28px 0;\n  margin-bottom: 10px;\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 12px 28px;\n  font-size: 14px;\n\n  strong {\n    font-weight: normal;\n    color: ",
        ";\n  }\n\n  &:hover {\n    background-color: #f5f5f5;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n  padding-left: 28px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8dc671f-0"
})(style_templateObject());
var SearchIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8dc671f-1"
})(style_templateObject1());
var InputSearchCompany = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-b8dc671f-2"
})(style_templateObject2());
var SuggestionCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8dc671f-3"
})(style_templateObject3());
var SuggestionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8dc671f-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});
var SuggestionCompanyItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b8dc671f-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
});
var NoData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8dc671f-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/components/SearchCompany/index.tsx






function SearchCompany(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, onClick = param.onClick;
    var ref = (0,react.useState)(), dirty = ref[0], setDirty = ref[1];
    var ref1 = (0,react.useState)(), disabledFetch = ref1[0], setDisabledFetch = ref1[1];
    var ref2 = (0,react.useState)(defaultValue), queryCompany = ref2[0], setQueryCompany = ref2[1];
    var ref3 = (0,react.useState)(), suggestionModalOpen = ref3[0], setSuggestionModalOpen = ref3[1];
    var data = (0,useCompanyAutoComplete/* default */.Z)(queryCompany).data;
    var handleChange = function(e) {
        setQueryCompany(e.target.value);
        if (!dirty) {
            setDirty(true);
        }
        if (disabledFetch) {
            setDisabledFetch(false);
        }
    };
    var handleClick = function(e, company) {
        e.stopPropagation();
        setQueryCompany(company.name);
        setSuggestionModalOpen(false);
        setDisabledFetch(true);
        if (onClick) {
            onClick(company);
        }
    };
    (0,useDocumentClick/* default */.Z)(function() {
        return setSuggestionModalOpen(false);
    });
    (0,react.useEffect)(function() {
        if (data && !disabledFetch) {
            setSuggestionModalOpen(true);
        } else {
            setSuggestionModalOpen(false);
        }
    }, [
        data,
        disabledFetch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                    width: 18,
                    color: "#d6d6d6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputSearchCompany, {
                placeholder: "회사를 검색해주세요.",
                value: queryCompany,
                onChange: handleChange
            }),
            suggestionModalOpen && dirty && queryCompany !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestionCompany, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionTitle, {
                        children: "검색결과"
                    }),
                    (data === null || data === void 0 ? void 0 : data.numFound) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoData, {
                        children: "검색결과가 없습니다."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: data === null || data === void 0 ? void 0 : data.docs.map(function(company) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestionCompanyItem, {
                                onClick: function(e) {
                                    return handleClick(e, company);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: company.name
                                    }),
                                    " / ",
                                    company.location
                                ]
                            }, "jobdom-write-".concat(company.PK_NM_HASH));
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/helper.ts

function handlePostJobdom(param) {
    var jobdomNumber = param.jobdomNumber, isWriteMode = param.isWriteMode, category = param.category, content = param.content, password = param.password, selectedCompanyHash = param.selectedCompanyHash, hashtags = param.hashtags, title = param.title, userName = param.userName;
    if (!title) {
        alert("제목을 입력해주세요.");
        return;
    }
    if (!content) {
        alert("내용을 입력해주세요.");
        return;
    }
    if (!userName) {
        alert("닉네임을 입력해주세요.");
        return;
    }
    if (!password || password.length < 4) {
        alert("비밀번호를 입력해주세요.");
        return;
    }
    var payload = {
        CATEGORY_ID: category !== null && category !== void 0 ? category : "N",
        CONTENT: content,
        PASSWORD: password,
        PK_NM_HASH: selectedCompanyHash || "",
        TAG_LIST: hashtags || "",
        TITLE: title,
        USER_NAME: userName
    };
    var apiUrl = isWriteMode ? "/api/jobdom/write" : "/api/jobdom/edit";
    if (!isWriteMode) {
        payload["JOBDOM_NO"] = jobdomNumber;
    }
    return isWriteMode ? axios_default().post(apiUrl, payload) : axios_default().put(apiUrl, payload);
}
function isInvalidHashTags(hashtags) {
    return (hashtags === null || hashtags === void 0 ? void 0 : hashtags.length) === 0 || (hashtags === null || hashtags === void 0 ? void 0 : hashtags.length) === 1 && hashtags[0] === "";
}

;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/style.ts

function ModalJobdomEditor_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 900px;\n  width: 100%;\n  padding: 30px 60px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  background: #f6f6f6;\n  z-index: 1201;\n\n  ",
        " {\n    height: 100%;\n    top: 0;\n    left: 0;\n    padding: 60px 16px 0;\n    transform: translate3d(0, 0, 0);\n  }\n"
    ]);
    ModalJobdomEditor_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalJobdomEditor_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 20px;\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 1.5;\n"
    ]);
    ModalJobdomEditor_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalJobdomEditor_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n  > div {\n    width: 100%;\n\n    input {\n      font-size: 16px;\n\n      &::placeholder {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    ModalJobdomEditor_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalJobdomEditor_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 250px;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  border-radius: 4px;\n  border: 1px solid #ebebeb;\n  font-size: 14px;\n  line-height: 1.6;\n\n  &:focus {\n    border-color: ",
        ";\n  }\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  ",
        " {\n    min-height: 200px;\n  }\n"
    ]);
    ModalJobdomEditor_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 140px;\n  height: 40px;\n  margin-right: 11px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 16.5px;\n  background-color: #ffffff;\n  outline: 0;\n  border: none;\n  padding-left: 15px;\n  appearance: none;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: 14px;\n"
    ]);
    style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0 10px;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 32px;\n  line-height: 32px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  padding: 0 12px;\n  border-radius: 30px;\n  font-weight: bold;\n  font-size: 12px;\n  background: none;\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 360px;\n  height: 30px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #d6d6d6;\n  padding-left: 40px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 2px;\n  left: 0;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 30px;\n  line-height: 30px;\n  background: none;\n  border-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  outline: 0;\n  appearance: none;\n  background-color: transparent;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  transform: translate3d(0, 100%, 0);\n  width: 100%;\n  min-height: 180px;\n  max-height: 340px;\n  padding: 16px 0 8px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n  z-index: 1001;\n  overflow-y: auto;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 28px 0;\n  margin-bottom: 10px;\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 12px 28px;\n  font-size: 14px;\n\n  strong {\n    font-weight: normal;\n    color: ",
        ";\n  }\n\n  &:hover {\n    background-color: #f5f5f5;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 16px;\n  top: 16px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n\n    button {\n      width: 100%;\n      border-radius: 0;\n      text-align: center;\n      justify-content: center;\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}

var cssWrapper = (0,styled_components_browser_esm/* css */.iv)(ModalJobdomEditor_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var WarningMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-0"
})(ModalJobdomEditor_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-1"
})(ModalJobdomEditor_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
});
var Textarea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    componentId: "sc-cea58fdf-2"
})(ModalJobdomEditor_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var MyInfoArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-3"
})(style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var MyInfoInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-cea58fdf-4"
})(style_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var BottomArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-5"
})(style_templateObject6());
var CategorySelectWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-6"
})(_templateObject7());
var ButtonCategory = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cea58fdf-7"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, function(param) {
    var selected = param.selected;
    return selected && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), function(param) {
        var theme = param.theme;
        return theme.colors.gray800;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.gray800;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.white100;
    });
});
var SearchCompanyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-8"
})(_templateObject10());
var style_SearchIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-9"
})(_templateObject11());
var style_InputSearchCompany = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-cea58fdf-10"
})(_templateObject12());
var style_SuggestionCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-11"
})(_templateObject13());
var style_SuggestionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-12"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});
var style_SuggestionCompanyItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-cea58fdf-13"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
});
var ButtonCloseWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-14"
})(_templateObject16());
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cea58fdf-15"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/board/ModalJobdomEditor/index.tsx













function ModalJobdomEditor(param) {
    var isOpen = param.isOpen, handleClose = param.handleClose, defaultValues = param.defaultValues;
    var router = (0,next_router.useRouter)();
    var isActiveUser = (0,useMyInfoQuery/* default */.Z)().isActiveUser;
    var ref = (0,react.useState)(defaultValues.categoryId), category = ref[0], setCategory = ref[1];
    var ref1 = (0,react.useState)(defaultValues.hashtags), hashtags = ref1[0], setHashTags = ref1[1];
    var ref2 = (0,react.useState)(defaultValues.title), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react.useState)(defaultValues.content), content = ref3[0], setContent = ref3[1];
    var ref4 = (0,react.useState)(defaultValues.userName), userName = ref4[0], setUserName = ref4[1];
    var ref5 = (0,react.useState)(defaultValues.password), password = ref5[0], setPassword = ref5[1];
    var ref6 = (0,react.useState)({
        hash: defaultValues.PK_NM_HASH,
        name: defaultValues.companyName
    }), selectedCompany = ref6[0], setSelectedCompany = ref6[1];
    var handleSubmit = function() {
        var successMessage = defaultValues.mode === "write" ? "게시글이 정상적으로 등록되었습니다" : "게시글이 정상적으로 수정되었습니다.";
        var result = handlePostJobdom({
            isWriteMode: defaultValues.mode === "write",
            category: category,
            content: content,
            password: password,
            selectedCompanyHash: selectedCompany === null || selectedCompany === void 0 ? void 0 : selectedCompany.hash,
            hashtags: hashtags,
            title: title,
            userName: userName,
            jobdomNumber: defaultValues.jobdomNumber
        });
        if (result) {
            result.then(function() {
                var ref;
                (0,thirdPartyEvent/* setGtmDataLayer */.id)("company__board__write__complete", {
                    tag: category ? (ref = constants/* JOBDOM_CATEGORIES.find */.v.find(function(_category) {
                        return _category.id === category;
                    })) === null || ref === void 0 ? void 0 : ref.text : null,
                    title: title,
                    companyName: !selectedCompany.name ? null : selectedCompany.name
                });
                alert("".concat(successMessage).concat(!isActiveUser ? " 로그인 후 게시글을 확인해 주세요." : ""));
                if (defaultValues.onSuccess) {
                    defaultValues.onSuccess();
                }
            }).catch(function(err) {
                console.log(err);
                alert("저장중 문제가 발생했습니다. 관리자에게 문의 부탁드립니다.");
            });
        }
    };
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", function() {
            return handleClose();
        });
        return function() {
            router.events.off("routeChangeComplete", function() {
                return handleClose();
            });
        };
    }, [
        router.events
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBase/* default */.Z, {
        inlineCss: cssWrapper,
        isOpen: isOpen,
        handleClose: handleClose,
        hasCloseButton: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySelectWrapper, {
                children: constants/* JOBDOM_CATEGORIES.map */.v.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.id !== "A" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonCategory, {
                            selected: item.id === category,
                            onClick: function() {
                                if (item.id !== category) {
                                    setCategory(item.id);
                                } else {
                                    setCategory("");
                                }
                            },
                            children: item.text
                        })
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany, {
                defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.companyName,
                onClick: function(company) {
                    return setSelectedCompany({
                        hash: company.PK_NM_HASH,
                        name: company.name
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningMessage, {
                children: "다른 사람의 인격권을 침해하거나 명예를 훼손하게 하는 글, 불쾌감을 주는 욕설 또는 비방하는 글, 유언비어나 허위사실을 유포하는 글, 도배성 글의 경우 글이 삭제되거나 이용제재를 받을 수 있습니다."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    placeholder: "*제목을 입력해주세요.",
                    value: title,
                    onChange: function(e) {
                        return setTitle(e.target.value);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, {
                placeholder: "*내용을 입력해주세요.",
                value: content,
                onChange: function(e) {
                    return setContent(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputHashtag, {
                onChange: function(hashTags) {
                    return setHashTags(hashTags);
                },
                defaultValue: isInvalidHashTags(defaultValues.hashtags) ? undefined : defaultValues.hashtags
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomArea, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyInfoArea, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyInfoInput, {
                                placeholder: "*닉네임 10자리까지",
                                maxLength: 10,
                                value: userName,
                                onChange: function(e) {
                                    return setUserName(e.target.value);
                                },
                                disabled: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.mode) === "edit"
                            }),
                            (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.mode) === "write" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MyInfoInput, {
                                type: "password",
                                placeholder: "*비밀번호 4자리",
                                maxLength: 4,
                                value: password,
                                onChange: function(e) {
                                    return setPassword(e.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: handleSubmit,
                            children: defaultValues.mode === "write" ? "게시" : "수정"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 10847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ JOBDOM_CATEGORIES; }
/* harmony export */ });
var JOBDOM_CATEGORIES = [
    {
        id: "A",
        text: "전체"
    },
    {
        id: "U",
        text: "강추"
    },
    {
        id: "D",
        text: "비추"
    },
    {
        id: "E",
        text: "취업고민"
    },
    {
        id: "S",
        text: "연봉고민"
    }, 
];


/***/ }),

/***/ 54909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": function() { return /* binding */ useGetJobdomByCompanyQuery; },
/* harmony export */   "C4": function() { return /* binding */ useJobdomDislikeMutation; },
/* harmony export */   "I_": function() { return /* binding */ useGetJobdomQuery; },
/* harmony export */   "No": function() { return /* binding */ useGetJobdomDetailQuery; },
/* harmony export */   "ZY": function() { return /* binding */ useJobdomCommentDislikeMutation; },
/* harmony export */   "a4": function() { return /* binding */ useJobdomLikeMutation; },
/* harmony export */   "dw": function() { return /* binding */ useGetJobdomCommentsQuery; },
/* harmony export */   "s9": function() { return /* binding */ useJobdomCommentLikeMutation; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_api_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35088);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24858);




/**
 * 잡담리스트 조회
 * @param param0
 * @returns
 */ function useGetJobdomQuery(param) {
    var _page = param.page, page = _page === void 0 ? 1 : _page, CATEGORY_ID = param.CATEGORY_ID, PK_NM_HASH = param.PK_NM_HASH, AVG_SALARY_FINAL = param.AVG_SALARY_FINAL, PRSN_BASE = param.PRSN_BASE, KEYWORD = param.KEYWORD;
    var payload = {};
    if (CATEGORY_ID) {
        payload["category"] = [
            "CATEGORY_ID",
            CATEGORY_ID
        ];
    }
    if (PK_NM_HASH) {
        payload["PK_NM_HASH"] = [
            "PK_NM_HASH",
            PK_NM_HASH
        ];
    }
    if (AVG_SALARY_FINAL) {
        payload["AVG_SALARY_FINAL"] = [
            "AVG_SALARY_FINAL",
            AVG_SALARY_FINAL
        ];
    }
    if (PRSN_BASE) {
        payload["PRSN_BASE"] = [
            "PRSN_BASE",
            PRSN_BASE
        ];
    }
    if (KEYWORD) {
        payload["KEYWORD"] = KEYWORD;
    }
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].jobdom */ .Z.jobdom,
        "list",
        page,
        KEYWORD,
        PK_NM_HASH,
        CATEGORY_ID
    ], function() {
        return (0,_lib_api_client__WEBPACK_IMPORTED_MODULE_0__/* .post */ .v_)("/api/jobdom/multiFilter/".concat(page, "/10"), payload);
    }, {
        enabled: !!page,
        refetchOnMount: true
    });
}
/**
 * 잡담 상세보기
 * @param jobdomId
 * @returns
 */ function useGetJobdomDetailQuery(jobdomId, onError) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].jobdom */ .Z.jobdom,
        "detail",
        jobdomId
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)("/api/jobdom/content/".concat(jobdomId));
    }, {
        enabled: !!jobdomId,
        refetchOnMount: true,
        onError: onError
    });
}
/**
 * 잡담 댓글조회
 * @param jobdomId
 * @returns
 */ function useGetJobdomCommentsQuery(jobdomId) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].jobdom */ .Z.jobdom,
        "comments",
        jobdomId
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)("/api/jobdomComments/fetch/".concat(jobdomId, "/1/100"));
    }, {
        enabled: !!jobdomId,
        refetchOnMount: true
    });
}
/**
 * 기업의 hash을 이용해 최대 3개만 기업의 잡담노출
 * @param companyHash
 * @returns
 */ function useGetJobdomByCompanyQuery(companyHash) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_2__/* ["default"].jobdom */ .Z.jobdom,
        "company",
        companyHash
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._)("/api/company/".concat(companyHash, "/posts"));
    }, {
        enabled: !!companyHash
    });
}
/**
 * 잡담 "좋아요" 업데이트
 * @param onSuccess
 * @returns
 */ function useJobdomLikeMutation(onSuccess) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(param) {
        var jobdomNumber = param.jobdomNumber, type = param.type;
        return (0,_lib_api_client__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)("/api/jobdom/like", {
            JOBDOM_NO: jobdomNumber,
            type: type
        });
    }, {
        onSuccess: onSuccess
    });
}
/**
 * 잡담 "싫어요" 업데이트
 * @param onSuccess
 * @returns
 */ function useJobdomDislikeMutation(onSuccess) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(param) {
        var jobdomNumber = param.jobdomNumber, type = param.type;
        return (0,_lib_api_client__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)("/api/jobdom/dislike", {
            JOBDOM_NO: jobdomNumber,
            type: type
        });
    }, {
        onSuccess: onSuccess
    });
}
/**
 * 잡담 코멘트 "좋아요" 업데이트
 * @param onSuccess
 * @returns
 */ function useJobdomCommentLikeMutation(onSuccess) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(param) {
        var commentNumber = param.commentNumber, type = param.type;
        return (0,_lib_api_client__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)("/api/jobdomComments/like", {
            COMMENT_NO: commentNumber,
            type: type
        });
    }, {
        onSuccess: onSuccess
    });
}
/**
 * 잡담 코멘트 "싫어요" 업데이트
 * @param onSuccess
 * @returns
 */ function useJobdomCommentDislikeMutation(onSuccess) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(param) {
        var commentNumber = param.commentNumber, type = param.type;
        return (0,_lib_api_client__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)("/api/jobdomComments/dislike", {
            COMMENT_NO: commentNumber,
            type: type
        });
    }, {
        onSuccess: onSuccess
    });
}


/***/ }),

/***/ 41771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useRouterQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);




function useRouterQuery(key) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (Array.isArray(key)) {
        return key.reduce(function(prev, curr) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, curr, router.query[curr]));
        }, {});
    }
    return router === null || router === void 0 ? void 0 : router.query[key];
}


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36902);



var initialState = {
    currentCategory: "A",
    modalReport: {
        open: false,
        jobdomNumber: undefined,
        commentNumber: undefined
    },
    modalJobdomEditor: {
        open: false,
        mode: "write",
        jobdomNumber: undefined,
        categoryId: undefined,
        content: undefined,
        password: undefined,
        companyName: undefined,
        PK_NM_HASH: undefined,
        hashtags: undefined,
        title: undefined,
        userName: undefined,
        onSuccess: undefined
    },
    modalAuthContent: {
        open: false,
        type: undefined,
        onAuthenticated: undefined,
        contentId: undefined
    },
    modalDeleteContent: {
        open: false,
        type: undefined,
        onAuthenticated: undefined,
        contentId: undefined
    }
};
var useJobdomBoardStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setCurrentCategory: function(category) {
            return set(function() {
                return {
                    currentCategory: category
                };
            });
        },
        setModalReport: function(newState) {
            return set(function() {
                return {
                    modalReport: newState
                };
            });
        },
        resetModalReport: function() {
            return set(function() {
                return {
                    modalReport: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState.modalReport)
                };
            });
        },
        setModalAuthContent: function(newState) {
            return set(function() {
                return {
                    modalAuthContent: newState
                };
            });
        },
        setModalDeleteContent: function(newState) {
            return set(function() {
                return {
                    modalDeleteContent: newState
                };
            });
        },
        setModalJobEditor: function(newState) {
            return set(function() {
                return {
                    modalJobdomEditor: newState
                };
            });
        },
        resetModalAuthContent: function() {
            return set(function() {
                return {
                    modalAuthContent: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState.modalAuthContent)
                };
            });
        },
        resetModalDeleteContent: function() {
            return set(function() {
                return {
                    modalDeleteContent: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState.modalDeleteContent)
                };
            });
        },
        resetModalJobEditor: function() {
            return set(function() {
                return {
                    modalJobdomEditor: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState.modalJobdomEditor)
                };
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useJobdomBoardStore);


/***/ }),

/***/ 2609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mo": function() { return /* binding */ increaseJobdomViewCount; },
/* harmony export */   "XS": function() { return /* binding */ getJobdomViewCount; },
/* harmony export */   "we": function() { return /* binding */ removeJobdomViewCount; }
/* harmony export */ });
/* harmony import */ var _utils_lodash_isServer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48086);

var JOBDOM_VIEW_COUNT = "JOBDOM_VIEW_COUNT";
function getJobdomViewCount() {
    if (_utils_lodash_isServer__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C) {
        var storage = window.localStorage;
        var viewCount = storage.getItem(JOBDOM_VIEW_COUNT);
        if (viewCount === null) {
            return 0;
        }
        return Number(viewCount);
    }
}
function removeJobdomViewCount() {
    if (_utils_lodash_isServer__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C) {
        var storage = window.localStorage;
        var viewCount = getJobdomViewCount();
        storage.removeItem(JOBDOM_VIEW_COUNT);
    }
}
function increaseJobdomViewCount() {
    if (_utils_lodash_isServer__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C) {
        var storage = window.localStorage;
        var viewCount = getJobdomViewCount();
        storage.setItem(JOBDOM_VIEW_COUNT, "".concat(viewCount + 1));
    }
}


/***/ }),

/***/ 5406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ switchToKebab; },
/* harmony export */   "V9": function() { return /* binding */ getKeyByValue; },
/* harmony export */   "YK": function() { return /* binding */ cleaningObj; }
/* harmony export */ });
function getKeyByValue(object, value) {
    var keys = Object.keys(object);
    return keys.find(function(key) {
        return object[key] === value;
    });
}
/*
 * object key값을 kebab 변환
 */ function switchToKebab(obj, prefix) {
    if (!obj) {
        return {};
    }
    var keys = Object.keys(obj);
    return keys.reduce(function(a, key) {
        var newKey = (prefix !== null && prefix !== void 0 ? prefix : "") + key.replace(/^([A-Z])/g, function($1) {
            return $1.toLowerCase();
        }).replace(/\_/g, "-").replace(/([A-Z])/g, function($1) {
            return "-".concat($1.toLowerCase());
        });
        a[newKey] = obj[key];
        return a;
    }, {});
}
/**
 * value가 undefined인 property 제거
 * @param obj
 */ function cleaningObj(obj) {
    if (!obj) {
        return {};
    }
    Object.keys(obj).forEach(function(key) {
        return obj[key] === undefined && delete obj[key];
    });
    return obj;
}


/***/ }),

/***/ 95129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ isEmpty; }
/* harmony export */ });
function isEmpty(value) {
    /** string & number & boolean check */ if (!value) {
        return true;
    }
    /** array & object check */ if (typeof value === "object") {
        return Object.keys(value).length === 0;
    }
    return false;
}


/***/ })

}]);